import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as _ from 'lodash'

import * as stylePresetType from 'constants/stylePresetType'
import { BG } from 'constants/customFieldTypes'
import { updateCustomStyleEffect, updateCustomStyleEffects, getCustomStyleClassName } from 'controllers/logic'
import SPColor from './stylePresetComponents/SPColor'
// import SPPosition from './stylePresetComponents/SPPosition'
import SPPositionZoomAll from './stylePresetComponents/SPPositionZoomAll'
import SPTextEffect from './stylePresetComponents/SPTextEffect'
// import SPZoom from './stylePresetComponents/SPZoom'
import SPDarkenLighten from './stylePresetComponents/SPDarkenLighten'
import SPAround from './stylePresetComponents/SPAround'
import SPTextSize from './stylePresetComponents/SPTextSize'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5em 1.1em 0.5em 1.5em;
`

class StylePresetsMain extends Component {

  getCurrentValue = (className, effectName) => {
    const customFields = this.props.app.customFields
    const currentValue = _.get(customFields, ['customStyles', className, effectName], {})
    return { ...currentValue }
  }

  updateEffect = (className, effectName) => {
    return (value) => {
      const { dispatch, app } = this.props
      dispatch(updateCustomStyleEffect(app, className, effectName, value))
    }
  }

  getClassName = (className) => {
    const { app, field } = this.props
    return getCustomStyleClassName(app, field, className)
  }

  updatePosizitionZoomEffects = (classNames, getSlideClassNameFn) => {
    return () => {
      const { dispatch, app } = this.props
      console.log('updatePositionZoomEffects', classNames)
      const slidesNumber = app.slidesCnt || 3 // TODO Hardcoded because no information in app, no slidesCnt when Shopify is enabled
      const positionValue = this.getCurrentValue(this.getClassName(classNames[0]), stylePresetType.POSITION)
      const zoomValue = this.getCurrentValue(this.getClassName(classNames[0]), stylePresetType.ZOOM)
      console.log('app', app)
      // Apply to all classNames
      classNames.forEach(classNameRaw => {
        const className = this.getClassName(classNameRaw)
        console.log('apply to', classNameRaw, ':', className)
        dispatch(updateCustomStyleEffects(app, className, {
          [stylePresetType.POSITION]: positionValue,
          [stylePresetType.ZOOM]: zoomValue,
        }))
      })
      // Apply to all slides also
      for (let i = 0; i < slidesNumber; i++) {
        dispatch(updateCustomStyleEffects(app, getSlideClassNameFn(i, app.customFields), {
          [stylePresetType.POSITION]: positionValue,
          [stylePresetType.ZOOM]: zoomValue,
        }))
      }
    }
  }

  renderPositionPreset (conf, index) {
    return null
    // return (
    //   <SPPosition
    //     key={index}
    //     currentValue={this.getCurrentValue(conf.className, conf.presetType)}
    //     onChange={this.updateEffect(conf.className, conf.presetType)}
    //     title={conf.title}
    //   />
    // )
  }

  renderPositionZoomAllPreset (conf, index) {
    return (
      <SPPositionZoomAll
        key={index}
        onChange={this.updatePosizitionZoomEffects(conf.classNames, conf.getSlideClassName, conf.presetType)}
        title={conf.title}
      />
    )
  }

  renderColorPreset (conf, index) {
    return (
      <SPColor
        key={index}
        currentValue={this.getCurrentValue(this.getClassName(conf.className), conf.presetType)}
        colors={conf.options} // the array of colors like ['black', 'white']
        onChange={this.updateEffect(this.getClassName(conf.className), conf.presetType)}
        title={conf.title}
      />
    )
  }

  renderTextEffectPreset (conf, index) {
    return (
      <SPTextEffect
        key={index}
        currentValue={this.getCurrentValue(this.getClassName(conf.className), conf.presetType)}
        onChange={this.updateEffect(this.getClassName(conf.className), conf.presetType)}
        title={conf.title}
      />
    )
  }

  renderZoom (conf, index) {
    return null
    // return (
    //   <SPZoom
    //     key={index}
    //     currentValue={this.getCurrentValue(conf.className, conf.presetType)}
    //     onChange={this.updateEffect(conf.className, conf.presetType)}
    //     title={conf.title}
    //   />
    // )
  }

  renderDarkenLighten (conf, index) {
    return (
      <SPDarkenLighten
        key={index}
        currentValue={this.getCurrentValue(this.getClassName(conf.className), conf.presetType)}
        onChange={this.updateEffect(this.getClassName(conf.className), conf.presetType)}
        title={conf.title}
      />
    )
  }
  renderAround (conf, index) {
    return (
      <SPAround
        key={index}
        currentValue={this.getCurrentValue(this.getClassName(conf.className), conf.presetType)}
        onChange={this.updateEffect(this.getClassName(conf.className), conf.presetType)}
        title={conf.title}
        isBgChange={this.props.field.type === BG}
      />
    )
  }

  renderTextSize (conf, index) {
    // let baseRem = document.getElementsByTagName('html')[0].style.fontSize.split('px')[0]
    // let fontSizeInPx = window.getComputedStyle(document.getElementsByClassName(conf.className)[0], null).getPropertyValue('font-size').split('px')[0]
    // const currentValue = Math.round(fontSizeInPx / baseRem * 100) / 100
    return (
      <SPTextSize
        key={index}
        // currentValue={currentValue}
        onChange={this.updateEffect(this.getClassName(conf.className), conf.presetType)}
        title={conf.title}
      />
    )
  }

  renderPreset = (conf, index) => {
    // console.log('render Preset conf', conf)
    switch (conf.presetType) {
      case stylePresetType.COLOR: return this.renderColorPreset(conf, index)
      case stylePresetType.POSITION: return this.renderPositionPreset(conf, index)
      case stylePresetType.TEXT_EFFECT: return this.renderTextEffectPreset(conf, index)
      case stylePresetType.ZOOM: return this.renderZoom(conf, index)
      case stylePresetType.TEXT_SIZE: return this.renderTextSize(conf, index)
      case stylePresetType.DARKEN_LIGHTEN: return this.renderDarkenLighten(conf, index)
      case stylePresetType.AROUND: return this.renderAround(conf, index)
      case stylePresetType.HIDDEN: return null
      case stylePresetType.POSITION_ZOOM_ALL: return this.renderPositionZoomAllPreset(conf, index)
      default: return <div>{conf.presetType} is not implemented yet</div>
    }
  }

  render () {
    const { field } = this.props
    if (field.stylePresets) {
      return (
        <Container>
          {field.stylePresets.map(this.renderPreset)}
        </Container>
      )
    } else {
      return null
    }
  }
}

StylePresetsMain.propTypes = {
  field: PropTypes.object,
  app: PropTypes.object
}

export default connect()(StylePresetsMain)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/StylePresetsMain.js